export default function ProblemSection() {
  const problems = [
    {
      icon: 'ri-shield-check-line',
      title: 'Gümrük Cezası Riskini Bitirin',
      description: 'Evraklar ve beyannameler arasındaki en ufak veri uyuşmazlığını tespit ederek firmanızı cezai yaptırımlardan korur.',
      metric: '%99,9',
      metricLabel: 'Doğruluk',
      color: '#10B981'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Operasyonel Körlüğü Kaldırın',
      description: 'Karmaşık faturalar ve binlerce satırlık çeki listeleri arasında insan gözünün kaçırdığı detayları yapay zeka yakalar.',
      metric: '10s',
      metricLabel: 'İşlem Hızı',
      color: '#2563EB'
    },
    {
      icon: 'ri-database-2-line',
      title: 'Hatalı Stok Girişine Engel Olun',
      description: 'Sipariş (PO) ile gelen malı satır satır eşleştirir. Tutarsızlık varsa sistem \'Circuit Breaker\' ile veri girişini otomatik durdurur.',
      metric: '0',
      metricLabel: 'Hata',
      color: '#F59E0B'
    },
  ];

  return (
    <section id="cozumler" className="bg-gradient-to-br from-[#F8F9FA] via-white to-[#F0F4F8] py-32 relative overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-[#2563EB]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#0EA5E9]/3 rounded-full blur-3xl"></div>

      <div className="max-w-[1400px] mx-auto px-8 relative z-10">
        {/* Section Title */}
        <div className="text-center mb-20">
          <div className="notion-fade-in inline-block px-4 py-2 rounded-full bg-[#2563EB]/10 border border-[#2563EB]/20 mb-6">
            <span className="text-[#2563EB] text-sm font-semibold">NİYE DOCAI?</span>
          </div>
          <h2 className="notion-fade-in text-5xl font-bold text-[#1E293B] mb-6" style={{ fontFamily: 'Playfair Display, serif', animationDelay: '0.1s' }}>
            Neden DocAI?
          </h2>
          <p className="notion-fade-in text-xl text-[#64748B] max-w-[700px] mx-auto" style={{ animationDelay: '0.2s' }}>
            Üretim ve ithalat süreçlerinizdeki kritik riskleri ortadan kaldırın
          </p>
        </div>

        {/* Problem Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-20">
          {problems.map((problem, index) => (
            <div
              key={index}
              className="notion-card-large group relative"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Gradient Border on Hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#2563EB]/10 to-transparent opacity-0 group-hover:opacity-100 smooth-transition rounded-3xl"></div>

              {/* Content */}
              <div className="relative z-10">
                {/* Icon Container */}
                <div className={`w-20 h-20 rounded-2xl flex items-center justify-center mb-8 smooth-transition group-hover:scale-110`} style={{ backgroundColor: `${problem.color}20` }}>
                  <i className={`${problem.icon}`} style={{ color: problem.color, fontSize: '2rem' }}></i>
                </div>

                {/* Metric Badge */}
                <div className="mb-6 pb-6 border-b-2 border-[#E2E8F0]">
                  <div className="text-4xl font-black" style={{ color: problem.color }}>
                    {problem.metric}
                  </div>
                  <div className="text-sm text-[#94A3B8] font-semibold mt-1">
                    {problem.metricLabel}
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold text-[#1E293B] mb-5">
                  {problem.title}
                </h3>

                {/* Description */}
                <p className="text-[17px] text-[#475569] leading-relaxed">
                  {problem.description}
                </p>

                {/* Hover Arrow */}
                <div className="mt-6 flex items-center opacity-0 group-hover:opacity-100 smooth-transition" style={{ color: problem.color }}>
                  <span className="text-sm font-semibold">Detay</span>
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 smooth-transition"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Row */}
        <div className="bg-white rounded-2xl p-8 border border-[#E2E8F0] shadow-md">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {[
              { icon: 'ri-database-line', number: '10.000+', label: 'Satır Veri/Saniye' },
              { icon: 'ri-line-chart-line', number: '2M+', label: 'İşlem Gerçekleşti' },
              { icon: 'ri-money-dollar-circle-line', number: '%45', label: 'Maliyet Tasarrufu' }
            ].map((stat, idx) => (
              <div key={idx} className="text-center group cursor-pointer">
                <div className="w-16 h-16 rounded-full bg-[#2563EB]/10 flex items-center justify-center mx-auto mb-4 group-hover:bg-[#2563EB]/20 smooth-transition">
                  <i className={`${stat.icon} text-[#2563EB] text-2xl`}></i>
                </div>
                <div className="text-3xl font-black text-[#2563EB] mb-2 group-hover:scale-110 smooth-transition" style={{ transformOrigin: 'center' }}>
                  {stat.number}
                </div>
                <div className="text-[#64748B] font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
